export interface DragOverlayProps {
  visible: boolean
}

/**
 * Full-page drag overlay that appears when files are dragged over the Documents page.
 * Provides visual feedback with an upload icon and instructional text.
 */
export function DragOverlay({ visible }: DragOverlayProps) {
  if (!visible) {
    return null
  }

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-blue-50/80 border-2 border-dashed border-blue-500 rounded-lg"
      aria-live="assertive"
      role="region"
      aria-label="File drop zone"
      data-testid="drag-overlay"
    >
      {/* Upload icon */}
      <svg
        className="w-16 h-16 mb-4 text-blue-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
        />
      </svg>

      {/* Instructional text */}
      <p className="text-lg font-semibold text-blue-600">
        Drop files to upload
      </p>
    </div>
  )
}

export default DragOverlay
